<template>
  <div class="container-fluid">
    <!-- Loop through each fund -->
    <div class="row mt-4" id="element-to-print">
      <div class="col-md-12 px-0">
        <div class="row">
          <div class="col-md-12">
            <div v-if="bookType == 'pdf'" class="row d-none">
              <table
                id="table"
                class="table remove-styles mt-0 col-md-12 table-hover table-header-area"
              >
                <thead>
                  <tr>
                    <th>
                      <div class="row">
                        <div class="col-md-12 d-flex justify-content-between">
                          <div>
                            <div class="s-20 fw-500">
                              Income Statement-Fund(Profit & Loss)
                            </div>
                            <div class="s-18 font-weight-600">
                              {{ tenantDisplayName }}
                            </div>
                            <div class="s-18 fw-500">
                              <span class="mr-1"> Date Range: </span>
                              <span>
                                {{ formatDate(startDate) }}
                                to {{ formatDate(endDate) }}
                              </span>
                            </div>
                          </div>
                          <div>
                            <img
                              :src="churchLogo"
                              v-if="churchLogo"
                              class="link-image mr-2"
                              alt=""
                            />
                            <img
                              src="../../../assets/dashboardlinks/churchcloud.png"
                              v-else
                              class="link-image mr-2"
                              alt=""
                            />
                          </div>
                        </div>
                      </div>
                    </th>
                  </tr>
                </thead>
              </table>
            </div>
          </div>
          <table
            class=" w-100 remove-styles2 mt-0 remove-border table-hover border-bottom-0 table-header-area"
          >
            <thead class="table-header-ar  border-0">
              <tr class="font-weight-bold border-0">
                <th class="text-dak">ACCOUNTS</th>
                <th class="text-right"></th>
                <th class="text-right text-dak s-14">
                  {{ formatDate(startDate) }} <br />
                  to {{ formatDate(endDate) }}
                </th>
              </tr>
            </thead>
          </table>
        </div>
        <div
          v-for="(fundData, fundName, index) in fundsData"
          :key="fundName"
          :class="{ 'mt-4': index > 0 }"
          class="row"
        >
          <div
            class="container-fluild border rounded mt-2 table-main remove-styles2 remove-border responsiveness"
          >
            <div class="s-18 font-weight-600 col-md-12 mt-2 text-dak">
              {{ fundName }}
            </div>

            <table
              class="table remove-styles mt-0 table-hover table-header-area"
            >
              <!-- Income Section -->
              <tbody>
                <tr class="table-header-area-main">
                  <td colspan="3">
                    <div class="fw-400 text-dak s-14">Income</div>
                  </td>
                </tr>
                <tr
                  v-for="(item, index) in fundData.income"
                  :key="`income-${index}`"
                >
                  <td>
                    <a
                      href="#"
                      class="text-decoration-none fw-500 s-14"
                      style="color: #0b55d4"
                    >
                      {{ item.accountName }}
                    </a>
                  </td>
                  <td></td>
                  <td class="text-right">
                    {{ currentUser.currencySymbol }}
                    {{ formatAmount(item.totalAmount) }}
                  </td>
                </tr>
                <tr class="total-row">
                  <td class="font-weight-bold">Total Income</td>
                  <td></td>
                  <td class="text-right font-weight-bold">
                    {{ currentUser.currencySymbol }}
                    {{ formatAmount(fundData.incomeTotal) }}
                  </td>
                </tr>
              </tbody>

              <!-- Expense Section -->
              <tbody>
                <tr class="table-header-area-main">
                  <td colspan="3">
                    <div class="fw-400 text-dak s-14">Expense</div>
                  </td>
                </tr>
                <tr
                  v-for="(item, index) in fundData.expense"
                  :key="`expense-${index}`"
                >
                  <td>
                    <a
                      href="#"
                      class="text-decoration-none fw-500 s-14"
                      style="color: #0b55d4"
                    >
                      {{ item.accountName }}
                    </a>
                  </td>
                  <td></td>
                  <td class="text-right">
                    {{ currentUser.currencySymbol }}
                    {{ formatAmount(item.totalAmount) }}
                  </td>
                </tr>
                <tr class="total-row">
                  <td class="font-weight-bold">Total Expense</td>
                  <td></td>
                  <td class="text-right font-weight-bold">
                    {{ currentUser.currencySymbol }}
                    {{ formatAmount(fundData.expenseTotal) }}
                  </td>
                </tr>
              </tbody>

              <!-- Fund Balance -->
              <tbody>
                <tr class="net-balance-row">
                  <td class="font-weight-bold">Fund Balance</td>
                  <td></td>
                  <td
                    class="text-right font-weight-bold"
                    :style="{ color: fundData.balance < 0 ? 'red' : 'inherit' }"
                  >
                    {{ currentUser.currencySymbol }}
                    {{ formatAmount(fundData.balance) }}
                  </td>
                </tr>
                <tr
                  class="table-header-area-main"
                  v-if="index === Object.keys(fundsData).length - 1"
                >
                  <td class="s-14">
                    <div class="text-dak font-weight-bold">Net Balance</div>
                  </td>
                  <td></td>
                  <td class="text-right text-dak s-14">
                    <div class="font-weight-bold">
                      {{ currentUser.currencySymbol }}
                      {{ formatAmount(netBalance) }}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, nextTick, watch, watchEffect, inject } from "vue";
import { useStore } from "vuex";
import axios from "@/gateway/backendapi";
import dateFormatter from "../../../services/dates/dateformatter";
import exportService from "../../../services/exportFile/exportserjs";

const props = defineProps({
  startDate: {
    type: String,
    default: "",
  },
  endDate: {
    type: String,
    default: "",
  },
  incomeStatementSummaryData: {
    type: Object,
    default: () => ({}),
  },
  fileHeaderToExport: {
    type: Array,
    required: true,
  },
  fileToExport: {
    type: Array,
    required: true,
  },
  fileName: {
    type: String,
    default: "",
  },
  bookType: {
    type: String,
    default: "",
  },
});
const store = useStore();
const tenantData = ref({});
const churchLogo = ref("");
const emit = defineEmits(["download-complete"]); // Add this line

watch(
  () => props.bookType,
  async (newVal, oldVal) => {
    if (!newVal || newVal === oldVal) return;

    try {
      if (newVal === "pdf") await nextTick();

      exportService.downLoadExcel(
        newVal,
        document.getElementById("element-to-print"),
        props.fileName,
        props.fileHeaderToExport,
        props.fileToExport
      );

      emit("download-complete", true);
    } catch (error) {
      emit("download-complete", false);
    }
  },
  { immediate: true } // Changed to true to catch all changes
);

// Sample Data

const currentUser = computed(() => {
  if (store && Object.keys(store.getters.currentUser).length > 0)
    return store.getters.currentUser;
  return "";
});

const totalExpense = (item) => {
  return item.reduce((sum, item) => sum + item.totalAmount, 0);
};
const totalIncome = (item) => {
  return item.reduce((sum, item) => sum + item.totalAmount, 0);
};
const calculateNetBalance = (data) => {
  let income = 0;
  let expense = 0;

  data.forEach((item) => {
    if (item.categoryName === "Income") {
      income += totalIncome(item.accounts);
    } else if (item.categoryName === "Expense") {
      expense += totalExpense(item.accounts);
    }
  });

  return income - expense;
};

const netBalance = computed(
  () =>
    calculateNetBalance(
      props.incomeStatementSummaryData.transactionsByAccountCategory
    ) // `transactions` should be your full list of `transacItem`s
);

const formatDate = (date) => {
  return dateFormatter.monthDayYear(date);
};

const fundsData = computed(() => {
  const funds = {};

  // Process all transactions
  props.incomeStatementSummaryData.transactionsByAccountCategory?.forEach(
    (category) => {
      category.accounts.forEach((account) => {
        const fundName = account.fund;

        // Initialize fund if not exists
        if (!funds[fundName]) {
          funds[fundName] = {
            income: [],
            expense: [],
            incomeTotal: 0,
            expenseTotal: 0,
            balance: 0,
          };
        }

        // Add to appropriate category
        if (category.categoryName === "Income") {
          funds[fundName].income.push(account);
          funds[fundName].incomeTotal += account.totalAmount;
        } else {
          funds[fundName].expense.push(account);
          funds[fundName].expenseTotal += Math.abs(account.totalAmount);
        }

        // Calculate balance
        funds[fundName].balance =
          funds[fundName].incomeTotal - funds[fundName].expenseTotal;
      });
    }
  );

  return funds;
});
const tenantDisplayName = computed(() => {
  if (!tenantData.value.churchName) return "";
  const name =
    tenantData.value.churchName.length < 20
      ? tenantData.value.churchName
      : `${tenantData.value.churchName.slice(0, 20)}...`;
  return name;
});
const getChurchProfile = async () => {
  try {
    let { data } = await axios.get(
      `/GetChurchProfileById?tenantId=${getUser.value.tenantId}`
    );
    console.log(data);
    churchLogo.value = data.returnObject.logo;
  } catch (err) {
    console.error(err);
  }
};
const getUser = computed(() => {
  if (
    !store.getters.currentUser ||
    (store.getters.currentUser &&
      Object.keys(store.getters.currentUser).length == 0)
  )
    return "";
  return store.getters.currentUser;
});
watchEffect(() => {
  if (getUser.value) {
    tenantData.value = getUser.value;
    getChurchProfile();
  }
});

// Format Amount
const formatAmount = (amount) =>
  amount.toLocaleString("en-NG", { minimumFractionDigits: 2 });
</script>

<style scoped>
.table th,
.table td {
  border-top: none;
}
.active {
  background: #ffffff;
  color: #08162e;
  font-weight: 700;
  width: 81px;
  height: 37px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  /* padding: 15px 0; */
}
.bg-secondary {
  background-color: #f8f9fa !important;
}
button.el-button {
  height: 36px !important;
  width: 139px !important;
  padding: 13px 24px !important;
  font-size: 13px !important;
}
.table-main {
  width: 100% !important;
  box-shadow: 0 0.063rem 0.25rem #02172e45 !important;
  /* border: 0.063rem solid #dde2e6 !important; */
  /* border-radius: 30px !important; */
  text-align: left !important;
  margin-bottom: auto !important;
  padding-bottom: 0.5rem !important;
}

.remove-styles {
  border: none !important;
  box-shadow: none !important;
  border-bottom: 0 !important;
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.remove-styles2 {
  padding-right: 0;
  padding-left: 0;
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}
table tbody tr,
table thead tr {
  border-bottom: 1px solid rgba(0, 0, 1, 0.2);
}
table tbody tr:first-child {
  border-bottom: none !important;
}
table tbody tr:last-child {
  border-bottom: none !important;
}

.remove-border {
  box-shadow: none !important;
}
.table {
  width: 100% !important;
  box-shadow: none !important;
  border: none !important;
  text-align: left;
  margin-bottom: auto !important;
  padding-bottom: 0.5rem;
}

.table thead th {
  font-weight: 700 !important;
  color: #000000 !important;
  font-size: 14px !important;
}
.table tbody tr {
  font-weight: 400 !important;
  color: #000000 !important;
  font-size: 14px !important;
}

.table-header-area-main {
  background-color: #d4dde4;
  /* background-color: #f4f4f4; */
}

.table-header-area {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
</style>
